import PropTypes from 'prop-types';

export const BLOCK_MIN_WIDTH = 67;
export const FIELD_MIN_WIDTH = 106;
export const WAREHOUSE_HEIGHT = 56;
export const COMMON_PADDING = 6;
export const FLD_BLOCK_HEIGHT = 250;
export const ROUTE_BLOCK_HEIGHT = 172;
export const PANEL_COLOR = '#f2f2f2';
export const FIELD_TXT_COLOR = '#41611c';
export const FIELD_ICO_COLOR = '#6c973a';
export const ROUTE_ICO_COLOR = '#47607c';
export const WAREHOUSE_ICO_COLOR = '#3f3915';
export const WAREHOUSE_CHART_COLOR = '#1976d2';

export const VEHICLE_STATES = {
  PAUSE: 'PAUSE',
  RESUME: 'RESUME',
};

export const ITEM_CONFIG = {
  warehouse: {
    title: 'Информация о складе',
    fields: [
      {
        name: 'name',
        label: 'Название',
        type: PropTypes.string,
      },
      {
        name: 'geozoneWait',
        label: 'Геозона очереди ожидания',
        type: PropTypes.string,
      },
      {
        name: 'geozoneUnload',
        label: 'Геозона разгрузки',
        type: PropTypes.string,
      },
      {
        name: 'queueLength',
        label: 'Кол-во мест в очереди ожидания',
        type: PropTypes.number,
      },
      {
        name: 'unloadSpeed',
        label: 'Скорость разгрузки, т/ч',
        type: PropTypes.number,
      },
      {
        name: 'dayCropCapacity',
        label: 'Производительность приема общая,т/д',
        type: PropTypes.number,
      },
      {
        name: 'hourCropCapacity',
        label: 'Производительность приема общая,т/час',
        type: PropTypes.number,
      },
      {
        name: 'minUnloadTime',
        label: 'Минимальное время разгрузки, мин',
        type: PropTypes.number,
      },
      {
        name: 'unloadStart',
        label: 'Начало разгрузки',
        isDate: true,
        type: PropTypes.string,
      },
      {
        name: 'unloadFinish',
        label: 'Завершение разгрузки',
        isDate: true,
        type: PropTypes.string,
      },
      {
        name: 'workdayStart',
        label: 'Начало дня',
        type: PropTypes.string,
      },
      {
        name: 'workdayFinish',
        label: 'Завершение дня',
        type: PropTypes.string,
      },
      {
        name: 'cropTypes',
        label: 'Культуры',
        isList: true,
        type: PropTypes.string,
      },
      {
        name: 'vehicleTypes',
        label: 'Типы автомобилей',
        type: PropTypes.string,
      },
    ],
  },
  field: {
    title: 'Информация о поле',
    fields: [
      {
        name: 'fieldName',
        label: 'Название',
        type: PropTypes.string,
      },
      {
        name: 'cropType',
        label: 'Культура',
        type: PropTypes.string,
      },
      {
        name: 'square',
        label: 'Площадь, га',
        type: PropTypes.number,
      },
      {
        name: 'geozoneName',
        label: 'Имя геозоны',
        type: PropTypes.string,
      },
      {
        name: 'cropPlanCapacity',
        label: 'Плановая урожайность, т',
        type: PropTypes.number,
      },
      {
        name: 'cropDensity',
        label: 'Насыпная плотность, л/т',
        type: PropTypes.number,
      },
      {
        name: 'harvestingStart',
        label: 'Начало сбора',
        type: PropTypes.string,
        isDate: true,
      },
      {
        name: 'harvestingFinish',
        label: 'Завершение сбора',
        type: PropTypes.string,
        isDate: true,
      },
      {
        name: 'workdayStart',
        label: 'Начало рабочего дня',
        type: PropTypes.string,
      },
      {
        name: 'workdayFinish',
        label: 'Завершение рабочего дня',
        type: PropTypes.string,
      },
      {
        name: 'cropFactDensity',
        label: 'Фактическая урожайность',
        type: PropTypes.string,
        isEditable: true,
      },
      {
        name: 'cropFactCapacity',
        label: 'Фактический объем урожая',
        type: PropTypes.number,
        isEditable: true,
      },
    ],
  },
  vehicle: {
    title: 'Транспортное средство',
    fields: [
      {
        name: 'model',
        label: 'Марка',
        type: PropTypes.string,
      },
      {
        name: 'regNum',
        label: 'Госномер',
        type: PropTypes.string,
      },
      {
        name: 'bodyVolume',
        label: 'Объем кузова, литр',
        type: PropTypes.number,
      },
      {
        name: 'trailerVolume',
        label: 'Объем прицепа, литр',
        type: PropTypes.number,
      },
      {
        name: 'availabilityStart',
        label: 'Начало доступности',
        type: PropTypes.string,
        isDate: true,
      },
      {
        name: 'availabilityFinish',
        label: 'Завершение доступности',
        type: PropTypes.string,
        isDate: true,
      },
      {
        name: 'workdayStart',
        label: 'Начало дня',
        type: PropTypes.string,
      },
      {
        name: 'workdayFinish',
        label: 'Завершение дня',
        type: PropTypes.string,
      },
      {
        name: 'geozoneName',
        label: 'Расположение',
        type: PropTypes.string,
      },
      {
        name: 'cropTypes',
        label: 'Разрешенные культуры',
        isList: true,
        type: PropTypes.string,
      },
      {
        name: 'bodyType',
        label: 'Особенности разгрузки (тип ТС)',
        type: PropTypes.string,
      },
    ],
  },
  harvester: {
    title: 'Уборочный комбайн',
    fields: [
      {
        name: 'model',
        label: 'Марка',
        type: PropTypes.string,
      },
      {
        name: 'regNum',
        label: 'Госномер',
        type: PropTypes.string,
      },
      {
        name: 'volume',
        label: 'Объем бункера, м3',
        type: PropTypes.number,
      },
      {
        name: 'productivity',
        label: 'Производительность, т/ч',
        editable: false,
        type: PropTypes.number,
      },
      {
        name: 'availabilityStart',
        label: 'Начало доступности',
        type: PropTypes.string,
        isDate: true,
      },
      {
        name: 'availabilityFinish',
        label: 'Завершение доступности',
        type: PropTypes.string,
        isDate: true,
      },
      {
        name: 'workdayStart',
        label: 'Начало дня',
        type: PropTypes.string,
      },
      {
        name: 'workdayFinish',
        label: 'Завершение дня',
        type: PropTypes.string,
      },
      {
        name: 'geozoneName',
        label: 'Расположение',
        type: PropTypes.string,
      },
      {
        name: 'cropTypes',
        label: 'Разрешенные культуры',
        isList: true,
        type: PropTypes.string,
      },
    ],
  },
};
